import "./UserSettings.scss";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../../store/authStore";
import { LogOut01 } from "@untitled-ui/icons-react";

function UserSettings({
  onClose,
  onOpenSettings,
  onOpenAccount,
  onOpenReceipts,
  onOpenAvatar,
}) {
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/login");
  }

  function handleChangePassword() {
    navigate("/change-password");
  }

  function handleOpenSettings() {
    // Close the UserSettings modal first
    if (onClose) {
      onClose();
    }

    // Use a small timeout to ensure the modal closes before opening the new one
    setTimeout(() => {
      if (onOpenSettings) {
        onOpenSettings();
      }
    }, 50);
  }

  function handleOpenAccount() {
    // Close the UserSettings modal first
    if (onClose) {
      onClose();
    }

    // Use a small timeout to ensure the modal closes before opening the new one
    setTimeout(() => {
      if (onOpenAccount) {
        onOpenAccount();
      }
    }, 50);
  }

  function handleOpenReceipts() {
    // Close the UserSettings modal first
    if (onClose) {
      onClose();
    }

    // Use a small timeout to ensure the modal closes before opening the new one
    setTimeout(() => {
      if (onOpenReceipts) {
        onOpenReceipts();
      }
    }, 50);
  }

  function handleOpenAvatar() {
    // Close the UserSettings modal first
    if (onClose) {
      onClose();
    }

    // Use a small timeout to ensure the modal closes before opening the new one
    setTimeout(() => {
      if (onOpenAvatar) {
        onOpenAvatar();
      }
    }, 50);
  }

  return (
    <>
      <div className="user-settings-content">
        <div className="top-bar-buttons">
          <div className="top-bar-modal-button" onClick={handleOpenSettings}>
            <div className="top-bar-button-icon">
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                settings
              </span>
            </div>
            <div className="top-bar-button-text">User Settings</div>
          </div>
          <div className="top-bar-modal-button" onClick={handleOpenAccount}>
            <div className="top-bar-button-icon">
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                account_circle
              </span>
            </div>
            <div className="top-bar-button-text">Account</div>
          </div>
          <div className="top-bar-modal-button" onClick={handleOpenReceipts}>
            <div className="top-bar-button-icon">
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                receipt_long
              </span>
            </div>
            <div className="top-bar-button-text">Receipts</div>
          </div>
          <div className="top-bar-modal-button" onClick={handleOpenAvatar}>
            <div className="top-bar-button-icon">
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                face
              </span>
            </div>
            <div className="top-bar-button-text">Avatar</div>
          </div>
          <div className="top-bar-modal-button" onClick={handleChangePassword}>
            <div className="top-bar-button-icon">
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                lock
              </span>
            </div>
            <div className="top-bar-button-text">Change Password</div>
          </div>
          <div className="top-bar-modal-button" onClick={handleLogout}>
            <div className="top-bar-button-icon">
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                logout
              </span>
            </div>
            <div className="top-bar-button-text">Log out</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserSettings;
